import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ElDialog } from 'element-plus'

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'CandidateDialog',
  props: {
    modelValue: { type: Boolean },
    width: { default: '560px' },
    showClose: { type: Boolean, default: false },
    alignCenter: { type: Boolean, default: false },
    closeOnClickModal: { type: Boolean, default: true }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {





const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElDialog), _mergeProps({
    "model-value": _ctx.modelValue,
    width: _ctx.width,
    "show-close": _ctx.showClose,
    "align-center": _ctx.alignCenter,
    "close-on-click-modal": _ctx.closeOnClickModal
  }, _ctx.$attrs, {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event)))
  }), _createSlots({ _: 2 }, [
    _renderList(_ctx.$slots, (_, slotName) => {
      return {
        name: slotName,
        fn: _withCtx((slotProps) => [
          _renderSlot(_ctx.$slots, slotName, _normalizeProps(_guardReactiveProps(slotProps || {})))
        ])
      }
    })
  ]), 1040, ["model-value", "width", "show-close", "align-center", "close-on-click-modal"]))
}
}

})